import { OpeningHoursDay } from '@/dto/scenario/load/OpeningHoursDay';
import { DtoExt } from '@/classes/scenario/DtoExt';

export class OpeningHoursDayExt extends DtoExt {

  public static fromDto(dto: OpeningHoursDay): OpeningHoursDayExt {
    return new OpeningHoursDayExt({
      isClosed: dto.isClosed,
      openingHour: dto.openingHour,
      closingHour: dto.closingHour,
      nightPercentage: dto.nightPercentage
    } as any);
  }

  public isClosed: boolean | null = null;

  public nightPercentage: number | null = null;

  public openingHour: number | null = null;

  public closingHour: number | null = null;

  constructor(options?: Partial<OpeningHoursDayExt> | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
      // this.isClosed = options.isClosed;
      // this.openingHour = options.openingHour;
      // this.closingHour = options.closingHour;
    }
  }

  public toDto(): OpeningHoursDay {
    return new OpeningHoursDay({
      isClosed: this.isClosed,
      openingHour: this.openingHour,
      closingHour: this.closingHour,
      nightPercentage: this.nightPercentage
    });
  }
}
